import { render, staticRenderFns } from "./ListItemHutangByAging.vue?vue&type=template&id=835c1c16&scoped=true"
import script from "./ListItemHutangByAging.vue?vue&type=script&lang=js"
export * from "./ListItemHutangByAging.vue?vue&type=script&lang=js"
import style0 from "./ListItemHutangByAging.vue?vue&type=style&index=0&id=835c1c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835c1c16",
  null
  
)

export default component.exports